<template>
  <div
    v-if="vatpham"
    class="item">
    <router-link :to="'/items/vatpham/' + vatpham.id">
      <span 
        v-if="vatpham.sale_off > 0" 
        class="rounder bg_red">
        <ul>
          <li class="text-center text-white">-{{ Number((vatpham.sale_off).toFixed(1)) }}%</li>
        </ul>
      </span>
      <div class="item-body">
        <div class="item-left">
          <img
            :src="base_url + vatpham.thumb"
            alt="item.slug"
            width="100%"
            height="100%"
            @error="replaceByDefault">

        </div>
        <div class="item-right">
          <ul>
            <li 
              v-if="vatpham.name.length > 50" 
              class="name-item">{{ vatpham.name.substring(0, 50) + "..." }}</li>
            <li
              v-else
              class="name-item">{{ vatpham.name }}</li>
            <li class="price">
              <b class="sale-price">{{ vatpham.price_sale }} đ</b>
            </li>
            <li class="item_nv">{{ vatpham.nv_item }} nhận xét</li>
          </ul>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
  import rating from '../include/rating'
  import ApiConfig from '../../communicate/ApiConfig'
  import defaultImage from '../../assets/images/default.png';

  export default {
    name: 'ItemVatPham',
    components: {
      rating
    },
    // eslint-disable-next-line vue/require-prop-types
    props: ['vatpham'],
    data() {
      return {
        base_url: ApiConfig.base_url
      }
    },
    methods: {
      replaceByDefault(e) {
        e.target.src = defaultImage;
      }
    }
  }
</script>

<style scoped>
  .item {
    /*height: 180px;*/
    width: 100%;
    cursor: pointer;
    padding: 5px;
    margin: 5px 0px;
  }
  .item .item-body {
    height: 100%;
    overflow: hidden;
    display: flex;
  }
  .item .item-body .item-left {
    width: 40%;

  }
  .item .item-body .item-left img{
    height: auto;
    max-height: 120px;
  }
  .item-body .item-right{
    width: 60%;
  }
  .item-right .name-item{
    color: #000;
  }
  .item-right .item_nv{
    color: #000;
  }
  .detail-item {
    position: relative;
    width: 100%;
    padding: 5px 0;
    margin-left: 10px;
    margin-top: 5px;
    border-top: .5px solid #418AEB;
    /*left: 44%;*/
  }
  .fa-chevron-right {
    position: absolute;
    right: 15px;
    font-size: 10px;
    bottom: 10px;
    color: #B50000;
  }
  .rounder {
    position: absolute;
    z-index: 2;
    height: 45px;
    width: 45px;
    border-radius: 50%;
  }

  .rounder ul {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .rounder ul li{
    font-weight: bold;
    font-size: 13px;
    color: #fff !important;
  }
  .bg_red{
    background-color: #B60001;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/item/ItemVatPham.vue